import {Component, computed, effect, OnDestroy, OnInit, signal} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {AuthService, LoadingComponent} from './core';
import {NotificationAlertComponent} from './core/components/notification/notification/notification-alert.component';
import {SideNavComponent} from './core/components/side-nav/side-nav.component';
import {Subscription} from 'rxjs';
import {LoadingService} from './core/components/loading/loading.service';
import {initFlowbite} from 'flowbite';
import {NotificationService} from './shared/services/notification.service';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, NotificationAlertComponent, SideNavComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();
  isLoading = computed(() => this.loadingService.isLoading());
  showError: boolean = false;
  private querySub: Subscription | undefined;

  updateAvailable = signal(false);

  constructor(
    private router: Router,
    protected loadingService: LoadingService,
    public notificationService: NotificationService,
    protected authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private swUpdate: SwUpdate,

  ) {}

  get notifications() {
    return this.notificationService.notification;
  }

  ngOnInit(): void {
    initFlowbite();

    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
        }
      })
    );

    // Initialize Service Worker update handling
    this.initServiceWorkerUpdates();
  }

  private initServiceWorkerUpdates(): void {
    if (this.swUpdate.isEnabled) {
      // Check for updates periodically
      this.checkForUpdates();

      // Listen for available updates
      this.subscriptions.add(
        this.swUpdate.versionUpdates
          .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
          .subscribe(() => {
            this.updateAvailable.set(true);
            this.showUpdateNotification();
          })
      );

      this.subscriptions.add(
        this.swUpdate.unrecoverable.subscribe(event => {
          console.error('Service worker in unrecoverable state:', event.reason);
          this.notificationService.set({
            type: 'error',
            message: 'App encountered an error. Please refresh the page.',
          });
        })
      );
    }
  }

  private checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();

      setInterval(() => {
        this.swUpdate.checkForUpdate();
      }, 5 * 60 * 1000);
    }
  }

  private showUpdateNotification(): void {
    const shouldUpdate = confirm('A new version of the app is available. Would you like to update now?');
    if (shouldUpdate) {
      this.activateUpdate();
    }
  }

  activateUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.updateAvailable.set(false);

      this.swUpdate.activateUpdate().then(() => {
        document.location.reload();
      });
    }
  }



  ngOnDestroy(): void {
    if (this.querySub)
      this.querySub.unsubscribe();

    this.subscriptions.unsubscribe();
  }

  triggerError() {
    this.showError = false;
    setTimeout(() => this.showError = true, 0);
  }
}
